// Pure stage-order helpers for the v2 case view (v1_673).
//
// Extracted from the render so the stage-aware ordering can be unit-tested
// deterministically: the render probe only reaches the login/list view, so it
// never exercises the authenticated case view, and mounting that view would
// mean mocking a whole session + case + report. These two pure functions carry
// the entire stage decision, and tools/harness-stage-order.mjs pins them.

// deriveDecideStage — true once the case is decided, OR nothing is outstanding
// (no document gaps and no OPEN AI red lines). This is the Decide-stage
// emphasis switch (brief §6): when it flips, the decision board and the MLRO
// decision surface above the action bar. Report-derived so it matches the
// data-stage the column uses. A red line is "open" when it is a bare string
// (legacy shape) or an object that is not resolved.
export function deriveDecideStage({ caseDecided, report, aiReview } = {}) {
  if (caseDecided) return true;
  if (!report) return false;
  if (((report.documentGaps) || []).length) return false;
  const redLines = ((aiReview || {}).redLines) || [];
  const anyOpen = redLines.some((rl) => rl && (typeof rl === 'string' || !rl.resolved));
  return !anyOpen;
}

// stageAttr — the data-stage attribute the CaseViewV2 root carries, from the
// decide switch plus the numeric stage (0 gather, 1 work, 2 decide). Only
// "decide" is consumed by CSS today (it lifts the decision cluster); "gather"
// and "work" are there for future stage-aware deltas and for legibility.
export function stageAttr({ decideStage, stage } = {}) {
  if (decideStage) return 'decide';
  return stage === 0 ? 'gather' : 'work';
}
